export default "__VITE_ASSET__DeMpLipu__"